import { render, staticRenderFns } from "./ProductionConfirmation.vue?vue&type=template&id=694e4d10&scoped=true&"
import script from "./ProductionConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProductionConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ProductionConfirmation.vue?vue&type=style&index=0&id=694e4d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694e4d10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VChip,VCol,VDivider,VIcon,VRow,VSimpleTable})
